<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
    <div fxFlex>Two Factor Authentication Setup</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>

  <mat-dialog-content class="mat-typography" fxFlex>
    <div fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="10px">
      <mat-horizontal-stepper [linear]="true" #stepper>
        <mat-step [stepControl]="firstFormGroup" [editable]="false" label="Type">
          <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
            <h3>
              Select one of available Authentication methods
              <ul>
                <li>
                  Authenticator - use mobile phone app like Google or Microsoft Authenticator to apply one-time code
                </li>
                <li>
                  SMS - use your messaging phone number to receive one-time code
                </li>
                <li>
                  E-MAIl - use your e-mail address to receive one-time code
                </li>
              </ul>
            </h3>
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
              <button mat-raised-button color="primary" (click)="setTwoAuthProvider('authenticator')">
                Authenticator
              </button>
              <button mat-raised-button color="primary" (click)="setTwoAuthProvider('phoneNumber')">
                SMS Message
              </button>
              <button mat-raised-button color="primary" (click)="setTwoAuthProvider('email')">
                E-mail
              </button>
            </div>
          </div>
        </mat-step>
        <mat-step [stepControl]="secondFormGroup" [formGroup]="secondFormGroup" label="Setup" [editable]="false">
          <app-mat-phone-number-input formControlName="phoneNumberCtrl" label="Phone Number to send one time code"
                                      *ngIf="selectedTwoFactorProvider == 'phoneNumber'"
                                      name="phoneNumberCtrl">
          </app-mat-phone-number-input>

          <app-mat-text-input formControlName="emailCtrl" label="E-mail address to send one time code"
                                      *ngIf="selectedTwoFactorProvider == 'email'"
                                      name="emailCtrl">
          </app-mat-text-input>

          <div *ngIf="twoFactorSetupModel">
            <h3 *ngIf="twoFactorSetupModel.qrCode">Scan QR Code with Authenticator app and click next</h3>
            <img *ngIf="twoFactorSetupModel.qrCode" alt="QR Code" src="{{twoFactorSetupModel.qrCode}}">
          </div>
          <div class="button-row" fxLayoutGap="20px">
            <button mat-raised-button type="button" (click)="previousStep()">Previous</button>
            <button mat-raised-button type="button" (click)="nextVerification()">Next</button>
          </div>
        </mat-step>
        <mat-step label="Verify" [stepControl]="thirdFormGroup" [formGroup]="thirdFormGroup" [editable]="false">
          <h3 *ngIf="twoFactorSetupModel && twoFactorSetupModel.message">
            {{twoFactorSetupModel.message}}
          </h3>

          <app-mat-text-input formControlName="verificationTokenCtrl"
                              label="Enter one time code to verify setup"
                              name="verificationTokenCtrl">
          </app-mat-text-input>

          <h3 *ngIf="isVerificationFailed" class="error-message">
            Verification Code is not valid, try to resend SMS or type an other code from Authenticator App
          </h3>
          <div class="button-row" fxLayoutGap="20px">
            <button mat-raised-button type="button" (click)="previousStep()">Previous</button>
            <button mat-raised-button type="button" *ngIf="selectedTwoFactorProvider == 'phoneNumber' || selectedTwoFactorProvider == 'email'"
                    (click)="resendVerificationToken()">Resend Code
            </button>
            <button mat-raised-button type="button" (click)="nextVerifyToken()">Next</button>
          </div>
        </mat-step>
        <mat-step label="Results" [editable]="false">
          <h3 *ngIf="isVerificationCompleted">
            Two Step Authentication setup is completed successfully
          </h3>
          <div class="button-row" fxLayoutGap="20px">
            <button mat-raised-button type="button" (click)="closeSendConfirmPopup('completed')">Close</button>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </mat-dialog-content>
</div>
